import { rankingData } from '@/mocks/home';

const trendIcons: Record<string, string> = {
  up: 'ri-arrow-up-line text-green-500',
  stable: 'ri-subtract-line text-foreground-400',
  new: 'ri-flashlight-line text-accent-500',
  down: 'ri-arrow-down-line text-red-500',
};

function formatHeat(n: number): string {
  if (n >= 10000000) return `${(n / 10000000).toFixed(1)}千万`;
  if (n >= 10000) return `${(n / 10000).toFixed(1)}万`;
  return `${n}`;
}

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热度榜单
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[500px] mx-auto">
            实时更新最受欢迎的影视内容排名
          </p>
        </div>
        <div className="max-w-[800px] mx-auto space-y-3">
          {rankingData.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer group"
            >
              <div className={`flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-lg font-heading font-bold text-lg ${
                item.rank === 1
                  ? 'bg-accent-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-secondary-500 text-background-50'
                  : item.rank === 3
                  ? 'bg-primary-400 text-background-50'
                  : 'bg-background-100 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <span className="text-sm font-heading font-bold text-foreground-900 truncate group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </span>
                  <span className="flex-shrink-0 px-2 py-0.5 rounded text-[10px] font-medium bg-background-100 text-foreground-500 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <span className="text-xs text-foreground-500">{item.source}</span>
              </div>
              <div className="flex-shrink-0 flex items-center gap-2">
                <span className="text-xs text-foreground-500 font-medium whitespace-nowrap">
                  {formatHeat(item.heat)}
                </span>
                <i className={`text-sm ${trendIcons[item.trend] || ''}`}></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}